export default __webpack_public_path__ + "barcode_svg.15dce4a16159cf20ea9ac942533d0512.svg";